import { render, staticRenderFns } from "./VerUbicaciones.vue?vue&type=template&id=708f5909"
import script from "./VerUbicaciones.vue?vue&type=script&lang=js"
export * from "./VerUbicaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports